﻿import { loadModules } from './foundation/moduleInitializer';

import { browserDetect } from './utilities/browser-detect';

import { loginMenu } from './feature/accounts/login';
import { marketingPreferences } from "./feature/accounts/marketing-preferences";
import { revealPassword } from './feature/accounts/reveal-password';
import { signInLink } from './feature/accounts/sign-in-link';

import { cookieBanner } from './feature/cta/cookie-banner';

import { bankAccountLookup } from './feature/order/bank-account-lookup';
import { downloadAgreement } from './feature/order/download-agreement';
import { postcodeLookup } from './feature/order/postcode-lookup';
import { requestPrice } from './feature/order/request-price';
import { stepIndicator } from './feature/order/step-indicator';

import { anchorList } from './feature/page-content/anchor-list';
import { faqAccordion } from './feature/page-content/page-accordion';
import { whyUsCarousel } from './feature/page-content/why-us-carousel';

import { burgerMenu } from './feature/navigation/burger-menu';
import { globalHeader } from './feature/navigation/global-header';
import { offCanvasNav } from './feature/navigation/primary-nav';


import { enableFormSubmission } from './feature/form/enable-form';
import { emailPrepopulateQuery } from './feature/form/prepopulate-email';
import { cookieConsent } from './feature/page-content/cookie-consent';


const app = (function() {

    const modules = [
        browserDetect,
        signInLink,
        anchorList,
        bankAccountLookup,
        burgerMenu,
        cookieBanner,
        emailPrepopulateQuery,
        postcodeLookup,
        enableFormSubmission,
        faqAccordion,
        globalHeader,
        loginMenu,
        offCanvasNav,
        revealPassword,
        requestPrice,
        stepIndicator,
        whyUsCarousel,
        downloadAgreement,
        marketingPreferences,
        cookieConsent
    ];

    return {
        init() {
            loadModules(modules);
        }
    };
})();

window.addEventListener('DOMContentLoaded', app.init);